<template>
  <hel-module title="成本分析" :class="scope.clsPrefix">
    <template slot="extra">
      <span :class="['trend-badge', growthRate >= 0 ? 'trend-up' : 'trend-down']">
        {{ growthRate >= 0 ? '+' : '' }}{{ growthRate.toFixed(1) }}%
      </span>
    </template>
    <div class="cost-container">

      <div class="cost-content">
        <div class="chart-center-text">
        <div class="center-label">总成本</div>
        <div class="center-value">{{ totalAmount }}</div>
        <div class="center-unit">万</div>
      </div>
        <div id="analysis_costChart" class="cost-chart">
      </div>
      <div class="cost-list">
        <div class="list-item" v-for="(item, index) in costItems" :key="index">
          <div class="item-header">
            <span class="item-dot" :style="{ background: item.color }"></span>
            <span class="item-name">{{ item.name }}</span>
          </div>
          <div class="item-value">{{ item.value }}</div>
        </div>
      </div>
      </div>

    </div>
  </hel-module>
</template>

<script>
import HelModule from './common/module/index.vue'
import * as echarts from 'echarts'
import axios from 'axios'
export default {
  name: 'CostAnalysis',
  components: {
    HelModule
  },
  props: {
    data: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      scope: {
        clsPrefix: 'rvc-cosmoplat-workspace-cost-analysis'
      },
      costItems: [
        { name: '原材料', value: '', color: '#4a5ff3', percent: 0, amount: 0 },
        { name: '人工', value: '', color: '#7D8EF5', percent: 0, amount: 0 },
        { name: '制造费用', value: '', color: '#ABB6F9', percent: 0, amount: 0 },
        { name: '管理费用', value: '', color: '#DADFFC', percent: 0, amount: 0 }
      ],
      totalAmount: 0,
      growthRate: 0
    }
  },
  computed: {},
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.fetchCostAnalysis()
    })
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    formatValue(value) {
      if (value >= 100000000) {
        return (value / 100000000).toFixed(1) + '亿'
      } else if (value >= 10000) {
        return (value / 10000).toFixed(0) + '万'
      } else {
        return value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '元'
      }
    },
    formatAmount(value) {
      return (value / 10000).toFixed(0)
    },
    async fetchCostAnalysis() {
      try {
        const now = new Date()
        const year = now.getFullYear().toString()
        const month = (now.getMonth()).toString()

        const response = await axios.post(
          'https://bigdata-cloud.cosmoplat.com/prod-api/system/api/call/costAnalysis',
          {
            secret: '9k0NVP',
            paramList: [
              { paramName: 'year', paramValue: year },
              { paramName: 'month', paramValue: month }
            ]
          },
          {
            headers: {
              'Content-Type': 'application/json'
            }
          }
        )

        console.log('成本分析接口返回:', response.data)

        if (response.data.code === 200 && response.data.data.length > 0) {
          const data = response.data.data[0]
          const totalCost = data.total_cost

          this.totalAmount = this.formatAmount(totalCost)
          this.growthRate = data.total_cost_growth_rate

          this.costItems = [
            {
              name: '原材料',
              value: this.formatValue(data.raw_material_cost),
              color: '#4a5ff3',
              amount: data.raw_material_cost
            },
            {
              name: '人工',
              value: this.formatValue(data.labor_cost),
              color: '#7D8EF5',
              amount: data.labor_cost
            },
            {
              name: '制造费用',
              value: this.formatValue(data.manufacturing_overhead),
              color: '#ABB6F9',
              amount: data.manufacturing_overhead
            },
            {
              name: '管理费用',
              value: this.formatValue(data.admin_expense),
              color: '#DADFFC',
              amount: data.admin_expense
            }
          ]

          this.$nextTick(() => {
            this.drawChart()
          })
        }
      } catch (error) {
        console.error('获取成本分析数据失败:', error)
      }
    },
    drawChart() {
      const chart = echarts.init(document.getElementById('analysis_costChart'))
      const option = {
        color: ['#4a5ff3', '#7D8EF5', '#ABB6F9', '#DADFFC'],
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c} ({d}%)'
        },
        series: [
          {
            type: 'pie',
            radius: ['70%', '100%'],
            center: ['50%', '50%'],
            avoidLabelOverlap: false,
            hoverAnimation: false,
            itemStyle: {
              // borderRadius: 4
            },
            label: {
              show: false,
              position: 'center'
            },
            labelLine: {
              show: false
            },
            data: this.costItems.map((item) => ({
              value: item.amount,
              name: item.name,
              itemStyle: {
                color: item.color
              }
            }))
          }
        ]
      }
      chart.setOption(option)
      this.chartInstance = chart
    },
    handleResize() {
      if (this.chartInstance) {
        this.chartInstance.resize()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$class-prefix: "rvc-cosmoplat-workspace-cost-analysis";
.#{$class-prefix} {
  .trend-badge {
    font-size: 12px;
    font-weight: 500;
    padding: 2px 8px;
    height: 16px;
    border-radius: 8px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 12px;
    line-height: 12px;
    &.trend-up {
      background: #F6FFED;
      color: #73B950;
    }
    &.trend-down {
      background: #FEEDED;
      color: #F44F4F;
    }
  }
  .cost-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: 10px 0;
  }
  .chart-center-text {
      position: absolute;
      top: 50%;
      left: calc(50% - 85px);
      transform: translate(-50%, -50%);
      text-align: center;
      z-index: 1000;
      .center-label {
      font-family: PingFangSC-Medium;
      font-weight: 600;
      font-size: 12px;
      color: #333333;
    }
    .center-value {
      font-size: 24px;
      font-weight: 700;
      color: #333;
      // line-height: 36px;
    }
    .center-unit {
      font-size: 12px;
      color: #333;
      font-family: PingFangSC-Medium;
    }
    }
  .cost-chart {
    position: relative;
    width: 130px;
    height: 130px;
    flex-shrink: 0;
    margin-right: 32px;

  }
  .cost-list {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 14px;
  }
  .list-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .item-header {
    // width: 100px;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .item-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
  }
  .item-name {
    font-size: 13px;
    color: #666666;
    font-weight: 400;
  }
  .item-value {
    font-size: 13px;
    color: #333333;
    font-weight: 600;
    text-align: left;
  }
}
.cost-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 300px;
  padding: 0px;
  // gap: 32px;
}
</style>
